var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dialog-edit-contact',{attrs:{"icon":"mdi-pencil","btn_color":"primary","title":"Editar"}}),_c('contact-form',{attrs:{"contact":_vm.contact,"read_only":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }